module.exports = __webpack_public_path__ + "fc420150c72941c06bb3f3837f00c636.ttf";